import { LegalPage } from "@/components/LegalPage";

export default function Refund() {
  return <LegalPage page="refund" testId="refund-page" />;
}
